import { render, staticRenderFns } from "./webloyalty.vue?vue&type=template&id=31b5f5b9"
import script from "./webloyalty.vue?vue&type=script&lang=ts&setup=true"
export * from "./webloyalty.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports